/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Interface, type ContractRunner } from "ethers";
import type { MinterMock, MinterMockInterface } from "../MinterMock";

const _abi = [
  {
    inputs: [
      {
        internalType: "uint256",
        name: "dungeonBiomeLevel",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "heroLevel",
        type: "uint256",
      },
    ],
    name: "amountForDungeon",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint64",
        name: "dungeonId",
        type: "uint64",
      },
      {
        internalType: "uint256",
        name: "dungeonBiomeLevel",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "heroLevel",
        type: "uint256",
      },
    ],
    name: "mintDungeonReward",
    outputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "mintDungeonRewardCalled",
    outputs: [
      {
        internalType: "uint64",
        name: "dungeonId",
        type: "uint64",
      },
      {
        internalType: "uint256",
        name: "dungeonBiomeLevel",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "heroLevel",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "dungeonBiomeLevel",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "heroLevel",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "setAmountForDungeon",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "setAmountToMint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

export class MinterMock__factory {
  static readonly abi = _abi;
  static createInterface(): MinterMockInterface {
    return new Interface(_abi) as MinterMockInterface;
  }
  static connect(address: string, runner?: ContractRunner | null): MinterMock {
    return new Contract(address, _abi, runner) as unknown as MinterMock;
  }
}
